import { Phone, CalendarCheck } from "lucide-react";

export default function MobileCTA({ onBookAppointment }) {
  return (
    <div data-testid="mobile-cta" className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-slate-200 shadow-lg">
      <div className="flex items-center gap-2 p-3">
        <a
          href="tel:+917075659696"
          data-testid="mobile-call-btn"
          className="flex-1 flex items-center justify-center gap-2 bg-navy text-white font-semibold py-3 rounded-lg text-sm"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <button
          data-testid="mobile-book-appointment-btn"
          onClick={onBookAppointment}
          className="flex-1 flex items-center justify-center gap-2 text-white font-semibold py-3 rounded-lg text-sm"
          style={{ background: "linear-gradient(135deg, #2E6FB8 0%, #1F4E79 100%)" }}
        >
          <CalendarCheck className="w-4 h-4" />
          Book Now
        </button>
      </div>
    </div>
  );
}
